import { ChangeDetectionStrategy, Component, computed, inject } from "@angular/core";
import { MatIcon } from "@angular/material/icon";
import { MatIconButton, MatButton } from "@angular/material/button";
import { DetectionService } from "../../../services/detection/detection.service";

@Component({
  selector: "lib-empty-panel",
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'flex-fill d-block overflow-hidden' },
  imports: [MatIcon, MatIconButton, MatButton],
  templateUrl: "./empty-panel.component.html",
  styleUrl: "./empty-panel.component.scss",
})
export class EmptyPanelComponent {
  protected readonly detection = inject(DetectionService);

  /** Friendly label for the run: "this run", "\"Cars\"", or "N object types". */
  protected readonly objectsLabel = computed(() => {
    const objs = this.detection.objects();
    if (objs.length === 0) return "this run";
    if (objs.length === 1) return `"${objs[0].name}"`;
    return `${objs.length} object types`;
  });

  protected readonly lowestThresholdPct = computed(() => {
    const [min] = this.detection.thresholdRange();
    return Math.round(min * 100);
  });

  protected readonly suggestedThresholdPct = computed(() => {
    const [min] = this.detection.thresholdRange();
    return Math.round(Math.max(0.5, min - 0.2) * 100);
  });
}